import React, { useEffect, useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../../../utils/Custom/text";
import CommonForm from "../../../../utils/commonComponent/commonForm";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../../utils/Custom/Button";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../../utils/commonComponent/axiosTokenConfig";
import axios from "axios";
import { BASE_URL } from "../../../../global";
import { getPermissions } from "../../rbac/hasAccess";
import { validateRequiredFields } from "../../../../utils/commonComponent/errorAlert";
import { Paper, TextField } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { designationOptions } from "../employeeConstants";
import { uploadJsonData, fetchJsonFromUrl } from "../../../../utils/commonComponent/handlejsonData";
import { generateEmpTrainingPDF } from "./generateEmpTrainingPDF";

export const checklistSections = [
    {
        sectionNo: 1,
        title: "Office Orientation",
        items: [
            {
                subSr: "A",
                label: "Office layout, seating arrangement",
                reference: "HR Manual / Discussion",
                keyPrefix: "officeSa",
            },
            {
                subSr: "",
                label: "Office timings, Attendance Register",
                reference: "HR Manual / Discussion",
                keyPrefix: "officeAr",
            },
            {
                subSr: "B",
                label: "Safety awareness",
                reference: "HR Manual / Discussion",
                keyPrefix: "officeSafety",
            },
            {
                subSr: "",
                label: "DYC safety standards",
                reference: "HR Manual / Discussion",
                keyPrefix: "officeDycSafety",
            },
            {
                subSr: "",
                label: "Escape route & Assembly point",
                reference: "HR Manual / Discussion",
                keyPrefix: "officeEscape",
            },
        ],
    },
    {
        sectionNo: 2,
        title: "Organization",
        items: [
            {
                subSr: "",
                label: "DYC Global Pvt Ltd. Introduction",
                reference: "Quality Manual / Discussion",
                keyPrefix: "orgIntro",
            },
            {
                subSr: "",
                label: "Responsibilities of individuals as per their role",
                reference: "Quality Manual / Discussion",
                keyPrefix: "orgResp",
            },
            {
                subSr: "",
                label: "Organisation structure",
                reference: "Quality Manual / Discussion",
                keyPrefix: "orgStructure",
            },
            {
                subSr: "",
                label: "DYC expectations",
                reference: "Quality Manual / Discussion",
                keyPrefix: "orgExpectations",
            },
        ],
    },
    {
        sectionNo: 3,
        title: "Inspection Coordination & Execution",
        items: [
            {
                subSr: "",
                label: "Overview of Inspection coordination process",
                reference: "Discussion",
                keyPrefix: "inspCoord",
            },
            {
                subSr: "",
                label: "Roles & responsibilities",
                reference: "Quality Manual / Discussion",
                keyPrefix: "inspRoles",
            },
            {
                subSr: "",
                label: "Overview of Work Instruction, Procedures and Inspection Reporting",
                reference: "Discussion",
                keyPrefix: "inspProcedures",
            },
            {
                subSr: "",
                label:
                    "Independence, Impartiality, Integrity & confidentiality & code of conduct, Protection of company / Client information (DYC/FMT-MR/13)",
                reference: "DYC/QP-IB/01 & Discussion",
                keyPrefix: "inspConduct",
            },
            {
                subSr: "",
                label: "Brief on logistics arrangement",
                reference: "HR manual / Discussion",
                keyPrefix: "inspLogistics",
            },
            {
                subSr: "",
                label:
                    "Importance of internal communication, reading of company emails including attachments",
                reference: "HR manual / Discussion",
                keyPrefix: "inspComm",
            },
            {
                subSr: "",
                label: "Asset Issue & use of DYC stamps",
                reference: "Work instructions / Discussion",
                keyPrefix: "inspAssets",
            },
        ],
    },
    {
        sectionNo: 4,
        title: "Training",
        items: [
            {
                subSr: "",
                label: "Competency requirements",
                reference: "Discussion / Quality manual",
                keyPrefix: "trainCompetency",
            },
            {
                subSr: "",
                label: "Training & monitoring process",
                reference:
                    "Discussion / DYC/QP-IB/02, DYC/QP-IB/03, DYC/QP-IB/04, DYC/QP-IB/05",
                keyPrefix: "trainMonitoring",
            },
            {
                subSr: "",
                label:
                    "Completion of Competency matrix & authorisation level, & Experience/training record (DYC/FMT-MR/14 & DYC/FMT-MR/16)",
                reference: "Discussion / DYC/QP-IB/03",
                keyPrefix: "trainMatrix",
            },
            {
                subSr: "",
                label: "Knowledge Transfer / Past Experience",
                reference: "Discussion",
                keyPrefix: "trainKnowledge",
            },
        ],
    },
    {
        sectionNo: 5,
        title: "Information Technology",
        items: [
            {
                subSr: "",
                label: "DYC Server / Shared folders",
                reference: "Discussion / DYC/QP-IB/06",
                keyPrefix: "itServer",
            },
            {
                subSr: "",
                label: "Phone & Emails (Outlook) Usage",
                reference: "Discussion / DYC/QP-IB/06",
                keyPrefix: "itEmails",
            },
            {
                subSr: "",
                label: "Computer / Laptop security",
                reference: "Discussion / DYC/QP-IB/06",
                keyPrefix: "itSecurity",
            },
        ],
    },
    {
        sectionNo: 6,
        title: "Invoicing process",
        items: [
            {
                subSr: "",
                label: "Overview of invoicing process",
                reference: "Discussion",
                keyPrefix: "invOverview",
            },
            {
                subSr: "",
                label: "Challenges in invoicing process",
                reference: "Discussion",
                keyPrefix: "invChallenges",
            },
            {
                subSr: "",
                label: "Payment follow up",
                reference: "Discussion",
                keyPrefix: "invFollowup",
            },
        ],
    },
    {
        sectionNo: 7,
        title: "Business development",
        items: [
            {
                subSr: "",
                label: "Overview of Enquiries, quotations process",
                reference: "Discussion",
                keyPrefix: "bdEnquiries",
            },
            {
                subSr: "",
                label: "DYC terms & conditions",
                reference: "Discussion",
                keyPrefix: "bdTerms",
            },
        ],
    },
    {
        sectionNo: 8,
        title: "On Job Training For Surveyors",
        isTextArea: true,
        subText:
            "Mention Details- Details such as supervisor's name, vendor details, scopes of training, dates of training, observations etc.",
        keyPrefix: "onJobTraining",
    },
];

const EditEmpTraining = (props) => {
    const params = useParams();
    const permissions = getPermissions(props.moduleId);
    const navigate = useNavigate();

    // Basic Header 
    const [inputStates, setInputStates] = useState({
        status: 1,
        employeeId: "",
        employeeName: "",
        designation: "",
        trainingStartDate: "",
        trainingEndDate: "",
        checklistUrl: "",
    });

    // Table Checklist Dynamic / Static Form State
    const [checklistData, setChecklistData] = useState({});

    // Employee Dropdown List
    const [employees, setEmployees] = useState([]);
    const [existingRow, setExistingRow] = useState(null);

    const updateInputObject = (key, value) => {
        setInputStates((prev) => {
            const next = { ...prev, [key]: value };
            if (key === "employeeId") {
                const selected = employees.find((e) => String(e.id) === String(value));
                if (selected) {
                    next.employeeId = selected.id;
                    next.employeeName = selected.name || "";
                    next.designation = selected.designation || "";
                    if (selected.dateOfJoining && !prev.trainingStartDate) {
                        try {
                            next.trainingStartDate = selected.dateOfJoining.split("T")[0];
                        } catch {
                            next.trainingStartDate = selected.dateOfJoining;
                        }
                    }
                } else {
                    next.employeeName = "";
                    next.designation = "";
                }
            }
            return next;
        });
    };

    // Update specific cell in the Checklist Table
    const handleChecklistChange = (key, value) => {
        setChecklistData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    //  Fetch dropdown options (Employees) from employees & employeeOtherData tables
    const fetchDropdownOptions = async () => {
        try {
            const empData = await fetchQuery(
                "SELECT e.id, e.name, e.employeesCode, e.dateOfJoining, eod.hrDesignation AS designation FROM employees e LEFT JOIN employeeOtherData eod ON eod.employeeId = e.id WHERE e.status != -1 ORDER BY e.name ASC"
            );
            setEmployees(empData || []);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    // Check existing row in EmployeeForms table
    const checkExistingRow = async (empId) => {
        const targetId = empId || params?.id || inputStates.employeeId;
        if (!targetId || targetId === "0") return;

        try {
            const checkQuery = {
                query: `SELECT id, inductionTrainingUrl FROM EmployeeForms WHERE employeeID = '${targetId}' LIMIT 1`,
            };
            const checkResponse = await axiosWithToken.post(BASE_URL + "dynamic", checkQuery);
            const row = checkResponse?.data?.[0] || null;
            setExistingRow(row);
        } catch (error) {
            console.error("Failed to check existing row in EmployeeForms:", error?.response?.data || error.message);
            setExistingRow(null);
        }
    };

    const handleFetch = async () => {
        if (!existingRow?.inductionTrainingUrl) return;
        try {
            const data = await fetchJsonFromUrl(existingRow.inductionTrainingUrl);
            if (data) {
                if (data.checklistData) setChecklistData(data.checklistData);
                else setChecklistData(data);

                setInputStates((prev) => ({
                    ...prev,
                    trainingStartDate: data.trainingStartDate || prev.trainingStartDate,
                    trainingEndDate: data.trainingEndDate || prev.trainingEndDate,
                    checklistUrl: existingRow.inductionTrainingUrl,
                }));
            }
        } catch (jsonErr) {
            console.error("Failed to load checklist JSON file:", jsonErr);
        }
    };

    // Submit Form
    const onSubmit = async () => {
        const targetEmpId = inputStates.employeeId || params?.id;
        const fieldsToValidate = [
            { value: targetEmpId, label: "Employee Name is required" },
            { value: inputStates.trainingStartDate, label: "Training Start Date is required" },
            { value: inputStates.trainingEndDate, label: "Training End Date is required" },
        ];

        if (!validateRequiredFields(fieldsToValidate)) return;

        try {
            // Step A: Upload json via uploadJsonData helper
            const payloadData = {
                ...inputStates,
                employeeId: targetEmpId,
                checklistData,
            };
            const uploadedJsonUrl = await uploadJsonData(payloadData);

            if (!uploadedJsonUrl) {
                console.error("Upload failed: no URL returned.");
                return;
            }

            // Step B: Save in EmployeeForms table 
            const sqlQuery = existingRow
                ? {
                    query: `UPDATE EmployeeForms SET inductionTrainingUrl = '${uploadedJsonUrl}' WHERE employeeID = '${targetEmpId}'`,
                }
                : {
                    query: `INSERT INTO EmployeeForms (employeeID, inductionTrainingUrl) VALUES ('${targetEmpId}', '${uploadedJsonUrl}')`,
                };

            await axiosWithToken.post(BASE_URL + "dynamic", sqlQuery);

            setExistingRow((prev) => prev || { id: targetEmpId, inductionTrainingUrl: uploadedJsonUrl });
        } catch (error) {
            console.error("Submission failed:", error?.response?.data || error.message);
        }
    };

    const handleDownload = async () => {
        try {
            const pdf = await generateEmpTrainingPDF(inputStates, checklistData, checklistSections);
            pdf.save(`Induction-Training-Record-${inputStates.employeeName || "Employee"}.pdf`);
        } catch (error) {
            console.error("PDF generation failed:", error);
            toast.error("Failed to generate PDF");
        }
    };

    useEffect(() => {
        fetchDropdownOptions();
    }, []);

    useEffect(() => {
        if (params.id && params.id !== "0") {
            // Check if params.id corresponds to an employee in dropdown
            const foundEmp = employees.find((e) => String(e.id) === String(params.id));
            if (foundEmp) {
                setInputStates((prev) => ({
                    ...prev,
                    employeeId: foundEmp.id,
                    employeeName: foundEmp.name,
                    designation: foundEmp.designation || "",
                }));
            }
            checkExistingRow(params.id);
        }
    }, [params?.id, employees]);

    useEffect(() => {
        if (existingRow?.inductionTrainingUrl) handleFetch();
    }, [existingRow?.inductionTrainingUrl]);

    // Top Header Input Fields
    const inputFields = [
        {
            type: "Autocomplete",
            label: "Employee *",
            stateKey: "employeeId",
            disabled: Boolean(params?.id && params.id !== "0"),
            options: employees.map((emp) => ({
                id: emp.id,
                name: `${emp.name} (${emp.employeesCode || "No Code"})`,
            })),
            valueKey: "id",
            getOptionLabelKey: "name",
        },
        {
            type: "TextField",
            label: "Employee Name",
            stateKey: "employeeName",
            disabled: true,
        },
        {
            type: "TextField",
            label: "Designation",
            stateKey: "designation",
        },
        {
            type: "DatePicker",
            label: "Training Start Date",
            stateKey: "trainingStartDate",
        },
        {
            type: "DatePicker",
            label: "Training End Date",
            stateKey: "trainingEndDate",
        },
    ];

    return (
        <>
        {(permissions.pdfDownload || permissions.allAccess) && (
                <div className="flex justify-end mb-4 gap-3">
                  <AddButton
                    id="btn-download-pdf"
                    hoverTitle="Download PDF"
                    icon={<DownloadIcon fontSize="small" />}
                    onClick={() =>handleDownload()}
                  />
                </div>
              )}
            <div className="flex justify-between items-center mb-6">
                <Text variant="h3" bold className="text-blue-600">
                    InductionTraining Record
                </Text>
            </div>

            {/* Top Basic Information Form */}
            <div className="mb-6">
                <CommonForm
                    inputStates={inputStates}
                    updateInputObject={updateInputObject}
                    inputFields={inputFields}
                />
            </div>

            {/* Main Induction Training Checklist Table */}
            <div className="mb-6">
                <Paper className="overflow-x-auto border border-gray-300">
                    <table className="w-full text-left border-collapse text-xs">
                        <thead>
                            <tr className="bg-gray-100 font-bold border-b border-gray-300">
                                <th className="p-2 border-r border-gray-300 text-center w-16">
                                    Sr. No.
                                </th>
                                <th className="p-2 border-r border-gray-300 w-1/3">
                                    Induction Details
                                </th>
                                <th className="p-2 border-r border-gray-300 w-1/4">
                                    Reference
                                </th>
                                <th className="p-2 border-r border-gray-300 text-center w-36">
                                    Date
                                </th>
                                <th className="p-2 text-center w-48">
                                    Responsible Person
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {checklistSections.map((sec) => {
                                if (sec.isTextArea) {
                                    return (
                                        <React.Fragment key={sec.sectionNo}>
                                            {/* Section Title Header */}
                                            <tr className="bg-blue-50 font-bold border-t border-b border-gray-300">
                                                <td className="p-2 border-r border-gray-300 text-center font-bold">
                                                    {sec.sectionNo}
                                                </td>
                                                <td colSpan={4} className="p-2">
                                                    <span className="font-bold text-gray-900">{sec.title}</span>
                                                    <span className="block text-gray-600 font-normal text-[11px] mt-0.5">
                                                        {sec.subText}
                                                    </span>
                                                </td>
                                            </tr>
                                            {/* Text area, supervisor details and sign */}
                                            <tr className="border-b border-gray-300">
                                                <td className="p-2 border-r border-gray-300 text-center">-</td>
                                                <td colSpan={2} className="p-2 border-r border-gray-300">
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={3}
                                                        placeholder="Enter training details, scopes of training, dates, observations..."
                                                        size="small"
                                                        variant="outlined"
                                                        value={checklistData[`${sec.keyPrefix}_details`] || ""}
                                                        onChange={(e) =>
                                                            handleChecklistChange(
                                                                `${sec.keyPrefix}_details`,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td className="p-2 border-r border-gray-300 align-top">
                                                    <TextField
                                                        fullWidth
                                                        placeholder="Supervisor Name"
                                                        size="small"
                                                        variant="outlined"
                                                        value={checklistData[`${sec.keyPrefix}_supervisor`] || ""}
                                                        onChange={(e) =>
                                                            handleChecklistChange(
                                                                `${sec.keyPrefix}_supervisor`,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td className="p-2 align-top text-center">
                                                    <TextField
                                                        fullWidth
                                                        placeholder="Sign"
                                                        size="small"
                                                        variant="outlined"
                                                        value={checklistData[`${sec.keyPrefix}_sig`] || ""}
                                                        onChange={(e) =>
                                                            handleChecklistChange(
                                                                `${sec.keyPrefix}_sig`,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                }

                                return (
                                    <React.Fragment key={sec.sectionNo}>
                                        {/* Section Header Row */}
                                        <tr className="bg-blue-50 font-bold border-t border-b border-gray-300">
                                            <td className="p-2 border-r border-gray-300 text-center font-bold">
                                                {sec.sectionNo}
                                            </td>
                                            <td colSpan={4} className="p-2 text-gray-900 font-bold">
                                                {sec.title}
                                            </td>
                                        </tr>

                                        {/* Section Item Rows */}
                                        {sec.items.map((item, itemIdx) => {
                                            const dtKey = `${item.keyPrefix}Dt`;
                                            const rpKey = `${item.keyPrefix}Rp`;

                                            return (
                                                <tr
                                                    key={itemIdx}
                                                    className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                                                >
                                                    <td className="p-2 border-r border-gray-300 text-center font-medium text-gray-600">
                                                        {item.subSr || ""}
                                                    </td>
                                                    <td className="p-2 border-r border-gray-300 text-gray-800">
                                                        {item.label}
                                                    </td>
                                                    <td className="p-2 border-r border-gray-300 text-gray-600 text-[11px]">
                                                        {item.reference}
                                                    </td>
                                                    <td className="p-1 border-r border-gray-300">
                                                        <input
                                                            type="date"
                                                            className="w-full border border-gray-300 rounded px-1.5 py-1 text-xs outline-none focus:border-blue-500"
                                                            value={checklistData[dtKey] || ""}
                                                            onChange={(e) =>
                                                                handleChecklistChange(dtKey, e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                    <td className="p-1">
                                                        <select
                                                            className="w-full border border-gray-300 rounded px-1.5 py-1 text-xs outline-none focus:border-blue-500 bg-white"
                                                            value={checklistData[rpKey] || ""}
                                                            onChange={(e) =>
                                                                handleChecklistChange(rpKey, e.target.value)
                                                            }
                                                        >
                                                            <option value="">Select Responsible Person</option>
                                                            {designationOptions.map((desig) => (
                                                                <option key={desig.id} value={desig.name}>
                                                                    {desig.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </Paper>
            </div>

            {/* Footer Signatures Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-6 p-4 border border-gray-300 rounded-md bg-gray-50">
                <div className="flex flex-col gap-2">
                    <span className="font-bold text-gray-700">Employee Authorization:</span>
                    <TextField
                        label="Name of Employee"
                        size="small"
                        variant="outlined"
                        value={checklistData["empSigName"] || inputStates.employeeName || ""}
                        onChange={(e) => handleChecklistChange("empSigName", e.target.value)}
                    />
                    <TextField
                        label="Date"
                        type="date"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={checklistData["empSigDate"] || ""}
                        onChange={(e) => handleChecklistChange("empSigDate", e.target.value)}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <span className="font-bold text-gray-700">Manager Authorization:</span>
                    <TextField
                        label="Name of Manager"
                        size="small"
                        variant="outlined"
                        value={checklistData["mgrSigName"] || ""}
                        onChange={(e) => handleChecklistChange("mgrSigName", e.target.value)}
                    />
                    <TextField
                        label="Date"
                        type="date"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={checklistData["mgrSigDate"] || ""}
                        onChange={(e) => handleChecklistChange("mgrSigDate", e.target.value)}
                    />
                </div>
            </div>

            {/* Buttons */}
            <div className="flex gap-4 mt-5 justify-end">
                <CancelButton
                    id="btn-cancel"
                    label="Cancel"
                    outline
                    onClick={() => {
                        if (window.confirm("Are you sure you want to cancel?")) {
                            window.history.back();
                        }
                    }}
                />
                {(permissions.save || permissions.allAccess) && (
                    <SaveAndUpdate
                        id="btn-save"
                        label={"Upload"}
                        onClick={onSubmit}
                    />
                )}
            </div>
        </>
    );
};

export default EditEmpTraining;
